// extracted by mini-css-extract-plugin
export var select = "_qt-0";